import React from "react";

/**
 * The v4 section label — small gold caps with a rule that runs out to the right
 * (mockup `.lbl`). A heading, not decoration: it names the section that follows,
 * so it renders as one and the rule is drawn by CSS rather than by an element a
 * screen reader would have to skip.
 */
const SupernovaSectionLabel = ({ as: Tag = "h3", children, className = "" }) => (
  <Tag className={`sn-lbl ${className}`.trim()}>{children}</Tag>
);

export default SupernovaSectionLabel;
